module.exports = __webpack_public_path__ + "img/China.d6b2d524.jpg";